import {
  erAmountType,
  MEMBERSHIPTYPE,
  MEMBERTYPE,
  STRATEGIES,
  WORK_ITEM_TYPE,
} from "../constants/constants";
import { v4 as uuidv4 } from "uuid";
import cmsConfig from "../redux/helpers/cmsConfig";
import DOMPurify from "dompurify";

export const autoCapitalize = (text, moreParams = "") => {
  text = text
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toLocaleUpperCase());
  text = text.replace(/(?:^|-)\w/g, (char) => char.toLocaleUpperCase());
  if (moreParams === "lastname") {
    //Allow capital letter after Mac/Mc
    const Mac = text.split("Mac");
    if (Mac[1]) {
      text =
        Mac[0] + "Mac" + Mac[1].charAt(0).toUpperCase() + Mac[1].substring(1);
    }
    const Mc = text.split("Mc");
    if (Mc[1]) {
      text = Mc[0] + "Mc" + Mc[1].charAt(0).toUpperCase() + Mc[1].substring(1);
    }
  }
  return text;
};

export const autoCase = (text) => {
  return text
    .toLowerCase()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
    .replace(/-([a-z])/g, (match, group1) => "-" + group1.toUpperCase());
};

export const checkNINumber = (nino) => {
  if (nino.slice(0, 2) === "TN") {
    if (/[FMfm]/.test(nino.charAt(8))) {
      return true;
    }
  } else {
    if (/[A-Da-d]/.test(nino.charAt(8))) {
      return true;
    }
  }
  return false;
};

export const calculateAge = (birthdate) => {
  const today = new Date();
  const birthDate = new Date(birthdate);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
};

export const calculateDecimalAge = (birthdate) => {
  const birthDate = new Date(birthdate);
  const today = new Date();

  // Difference in milliseconds
  const diffMs = today.getTime() - birthDate.getTime();

  // Convert milliseconds to days
  const diffDays = diffMs / (1000 * 60 * 60 * 24);

  // Convert days to years (accounting for leap years)
  const ageInYears = diffDays / 365.25;

  return parseFloat(ageInYears.toFixed(2));
};

// Get age and month
export const getAgeMonth = (dateString) => {
  const today = new Date();
  const DOB = new Date(dateString);
  let totalMonths =
    (today.getFullYear() - DOB.getFullYear()) * 12 +
    today.getMonth() -
    DOB.getMonth();
  totalMonths += today.getDay() < DOB.getDay() ? -1 : 0;
  let years = today.getFullYear() - DOB.getFullYear();
  if (DOB.getMonth() > today.getMonth()) years = years - 1;
  else if (DOB.getMonth() === today.getMonth())
    if (DOB.getDate() > today.getDate()) years = years - 1;
  let months;
  if (DOB.getDate() > today.getDate()) {
    months = totalMonths % 12;
    if (months == 0) months = 11;
  } else {
    if (DOB.getMonth() === today.getMonth()) months = totalMonths % 12;
    else months = (totalMonths % 12) + 1;
  }
  const age = years + " years " + months + " months";
  return age;
};

// Contributions effective date month and year
export const contributionEffectiveDateMonthYear = () => {
  let effectiveDate = "";
  const date = new Date();
  const currentDateTime = date.toLocaleString("en-GB", {
    timeZone: "GMT",
  });
  const datetime = currentDateTime.split(",");
  const month = parseInt(datetime[0].split("/")[1]);
  const year = parseInt(datetime[0].split("/")[2]);
  if (currentDateTime === getLastDayOfMonth(year, month)) {
    effectiveDate = getNextMonthFirstDay(year, month);
  } else if (currentDateTime === getCurrentMonthFirstDay(year, month)) {
    effectiveDate = getNextMonthFirstDay(year, month);
  } else {
    effectiveDate = getNextMonthFirstDay(year, month);
  }
  return effectiveDate.split(",")[0];
};

function getLastDayOfMonth(Year, Month) {
  let date = new Date(new Date(Year, Month, 1) - 1);
  return date.toLocaleString("en-GB", {
    timeZone: "GMT",
  });
}
function getNextMonthFirstDay(Year, Month) {
  let date = new Date(Year, Month, 2);
  return date.toLocaleString("en-GB", {
    timeZone: "GMT",
  });
}
function getCurrentMonthFirstDay(Year, Month) {
  let date = new Date(Year, Month - 1, 2);
  return date.toLocaleString("en-GB", {
    timeZone: "GMT",
  });
}

//Comma separated function

export const addCommas = (nStr) => {
  nStr += "";
  var x = nStr.split(".");
  var x1 = x[0];
  var x2 = x.length > 1 ? "." + x[1] : "";
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  return x1 + x2;
};

export const calculateUnits = (amount, sellUnitPrice) => {
  const numericAmount = parseFloat(amount);
  const numericSellUnitPrice = parseFloat(sellUnitPrice);

  if (
    !Number.isFinite(numericAmount) ||
    !Number.isFinite(numericSellUnitPrice) ||
    numericSellUnitPrice <= 0
  ) {
    return 0;
  }

  return numericAmount / numericSellUnitPrice;
};

//Enable and Disable fields based on member type
export const checkFormFieldAccess = (memberType) => {
  switch (memberType) {
    //Remove your field name from array If you want to disable the field
    //You can hide edit option for whole section by removing section name - ["mydetail-section","contact-section","address-section","bankdetail-section"]
    //my detail section field names - ['title','firstName','lastName','maritalStatus','maritalStatusDate','dateOfBirth','nino']
    //contact section field names - ['mobileNumber','homeNumber','email']
    //address section field names - ['propertyName','propertyNumber', 'street', 'street2', 'postcode', 'town', 'county', 'country']
    //bank section field names - ['bankName','sortCode', 'accountNumber', 'accountName', 'societyCode']
    case MEMBERTYPE.ACTIVE:
    case MEMBERTYPE.ACTIVE_SAVINGS:
      return [
        "contact-section",
        "address-section",
        "mobileNumber",
        "homeNumber",
        "email",
        "propertyName",
        "propertyNumber",
        "street",
        "street2",
        "postcode",
        "town",
        "county",
        "country",
      ];
    case MEMBERTYPE.ACTIVE_PENSIONER:
    case MEMBERTYPE.ACTIVE_SAVINGS_DRAWDOWN:
      return [
        "contact-section",
        "address-section",
        "bankdetail-section",
        "mobileNumber",
        "homeNumber",
        "email",
        "propertyName",
        "propertyNumber",
        "street",
        "street2",
        "postcode",
        "town",
        "county",
        "country",
        "bankName",
        "sortCode",
        "accountNumber",
        "accountName",
        "societyCode",
        "swift",
      ];
    case MEMBERTYPE.DEFERRED:
    case MEMBERTYPE.DEFERRED_SAVINGS:
      return [
        "mydetail-section",
        "contact-section",
        "address-section",
        "title",
        "firstName",
        "lastName",
        "maritalStatus",
        "maritalStatusDate",
        "dateOfBirth",
        "nino",
        "mobileNumber",
        "homeNumber",
        "email",
        "propertyName",
        "propertyNumber",
        "street",
        "street2",
        "postcode",
        "town",
        "county",
        "country",
      ];

    case MEMBERTYPE.DEFERRED_PENSIONER:
    case MEMBERTYPE.DEFERRED_SAVINGS_DRAWDOWN:
      return [
        "mydetail-section",
        "contact-section",
        "address-section",
        "bankdetail-section",
        "title",
        "firstName",
        "lastName",
        "maritalStatus",
        "maritalStatusDate",
        "mobileNumber",
        "homeNumber",
        "email",
        "propertyName",
        "propertyNumber",
        "street",
        "street2",
        "postcode",
        "town",
        "county",
        "country",
        "bankName",
        "sortCode",
        "accountNumber",
        "accountName",
        "societyCode",
        "swift",
      ];
    case MEMBERTYPE.PENSIONER:
    case MEMBERTYPE.PENSIONER_DRAWDOWN:
      return [
        "mydetail-section",
        "contact-section",
        "address-section",
        "bankdetail-section",
        "title",
        "firstName",
        "lastName",
        "maritalStatus",
        "maritalStatusDate",
        "mobileNumber",
        "homeNumber",
        "email",
        "propertyName",
        "propertyNumber",
        "street",
        "street2",
        "postcode",
        "town",
        "county",
        "country",
        "bankName",
        "sortCode",
        "accountNumber",
        "accountName",
        "societyCode",
        "swift",
      ];
    case MEMBERTYPE.DEPENDENT_PENSIONER:
    case MEMBERTYPE.DEPENDENT_PENSIONER_DRAWDOWN:
      return [
        "mydetail-section",
        "contact-section",
        "address-section",
        "bankdetail-section",
        "title",
        "firstName",
        "lastName",
        "maritalStatus",
        "maritalStatusDate",
        "mobileNumber",
        "homeNumber",
        "email",
        "propertyName",
        "propertyNumber",
        "street",
        "street2",
        "postcode",
        "town",
        "county",
        "country",
        "bankName",
        "sortCode",
        "accountNumber",
        "accountName",
        "societyCode",
        "swift",
      ];
    default:
      return [];
  }
};
export const checkFieldEnabled = (field, isEditClicked, formFieldAccess) => {
  const check = formFieldAccess?.includes(field);
  return isEditClicked
    ? true
    : check === true && isEditClicked === true
      ? true
      : check === false && isEditClicked === false
        ? true
        : check === true && isEditClicked === false
          ? false
          : true;
};
export const setCursorPostion = (e) => {
  const cursorPos = e.target.selectionStart;
  const element = e.target;
  window.requestAnimationFrame(() => {
    element.selectionStart = cursorPos;
    element.selectionEnd = cursorPos;
  });
};
// Contribution input change
export const contributionInputChange = (value) => {
  const validNumber = /^\d+(\.\d{0,2})?$/;
  return validNumber.test(value);
};

const filterArr = (arr) => {
  return arr.filter((value, index) => arr.indexOf(value) === index);
};
//Get required document list for personal details ID&V
export const documentsList = (workItemType, fields) => {
  let docArr = [];
  switch (workItemType) {
    case WORK_ITEM_TYPE.WORK_ITEM_PERSONAL_DETAIL:
      if (fields.includes("first name")) {
        docArr.push("Passport");
        docArr.push("Driving License");
        docArr.push("Deed Poll");
      }
      if (fields.includes("last name")) {
        docArr.push("Passport");
        docArr.push("Driving License");
        docArr.push("Deed Poll");
        docArr.push("Marriage Certificate");
        docArr.push("Civil Partnership Certificate");
      }
      if (fields.includes("nino")) {
        docArr.push("Passport");
        docArr.push("Driving License");
        docArr.push("Payslip");
        docArr.push("NI Certificate");
      }
      if (fields.includes("date of birth")) {
        docArr.push("Passport");
        docArr.push("Driving License");
        docArr.push("Birth Certificate");
      }
      if (
        fields.includes("marital status") ||
        fields.includes("marital status date")
      ) {
        docArr.push("Passport");
        docArr.push("Driving License");
        docArr.push("Marriage Certificate");
        docArr.push("Civil Partnership Certificate");
      }
      break;
    case WORK_ITEM_TYPE.WORK_ITEM_CONTACT_DETAIL:
      if (
        fields?.includes("mobile number") ||
        fields?.includes("mobile number") ||
        fields?.includes("personal email address")
      )
        docArr.push("Mobile Contract");
      docArr.push("Mobile Contract");
      break;
    case WORK_ITEM_TYPE.WORK_ITEM_ADDRESS_DETAIL:
      if (
        fields?.includes("property name") ||
        fields?.includes("property number") ||
        fields?.includes("street") ||
        fields?.includes("street 2") ||
        fields?.includes("town") ||
        fields?.includes("postcode") ||
        fields?.includes("county") ||
        fields?.includes("country")
      )
        docArr.push("Utility Bill");
      docArr.push("Utility Bill");
      break;
    case WORK_ITEM_TYPE.WORK_ITEM_BANK_DETAIL:
    case WORK_ITEM_TYPE.WORK_ITEM_BENEFIT_DETAIL:
      if (
        fields?.includes("bank name") ||
        fields?.includes("sort code") ||
        fields?.includes("account number") ||
        fields?.includes("account name") ||
        fields?.includes("building society code")
      )
        docArr.push("Bank Statement");
      docArr.push("Bank Statement");
      break;
    default:
      break;
  }
  return filterArr(docArr);
};

export const createFirstDayDates = (data, limit) => {
  const lastDayDates = [];

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  if (data !== undefined) {
    data.forEach((item) => {
      const monthIndex = monthNames?.findIndex(
        (name) => name.toLowerCase() === item?.month?.toLowerCase(),
      );

      const month = monthIndex !== -1 ? monthIndex + 1 : null;

      if (month !== null) {
        const year = parseInt(item.year, 10);

        const date = new Date(year, month - 1, 1);

        const formattedDate = `${date.getFullYear()}-${String(
          date.getMonth() + 1,
        ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

        lastDayDates?.push(formattedDate);
      } else {
        console.error(`Invalid Month name: ${item.month}`);
      }
    });

    const uncountedDate = limit - data?.length;
    let firstDate = lastDayDates[0] === undefined ? "" : lastDayDates[0];
    let [year, month] = firstDate.split("-").map(Number);

    for (let i = 0; i < uncountedDate; i++) {
      if (month === 1) {
        year--;
        month = 12;
      } else {
        month--;
      }
      let formattedDate = `${year}-${String(month).padStart(2, "0")}-01`;
      lastDayDates.unshift(formattedDate);
    }
  }
  return lastDayDates.slice(-limit);
};

export const extractValue = (data, limit) => {
  const values = [];

  if (data !== undefined) {
    data?.forEach((item) => {
      values.push(item.fundValue);
    });

    const uncountedValue = limit - data?.length;
    for (let i = 0; i < uncountedValue; i++) {
      values?.unshift(null);
    }
  }

  return values?.slice(-limit);
};

export const sumArrays = (array1, array2) => {
  let result = [];
  let maxLength;
  if (array1 !== undefined && array2 !== undefined) {
    maxLength = Math.max(array1.length, array2.length);
  }

  for (let i = 0; i < maxLength; i++) {
    let index1 = array1.length - i - 1;
    let index2 = array2.length - i - 1;
    let value1 = array1[index1] !== null ? array1[index1] : 0;
    let value2 = array2[index2] !== null ? array2[index2] : 0;
    result.unshift(value1 + value2 !== 0 ? value1 + value2 : null);
  }

  return result;
};

//COLOR_PALETTE
export const COLOR_PALETTE = [
  "#009d9a",
  "#a51890",
  "#151f6d",
  "#e97120",
  "#a82645",
  "#1192e8",
  "#03a54f",
  "#020ab5",
  "#240203",
  "#6229c4",
  "#732b02",
  "#61661f",
  "#92992e",
  "#db325a",
  "#730748",
  "#d520e9",
  "#006b69",
  "#0d72b5",
  "#1b377b",
  "#b55819",
  "#837859",
  "#020de8",
  "#a50b67",
  "#6960c7",
  "#570408",
  "#a619b5",
  "#027337",
  "#491e91",
  "#b28600",
  "#0f40ba",
  "#005d5d",
  "#0b2f87",
  "#806000",
  "#020a5b",
  "#002929",
  "#7a4cbd",
];

export const extractFunds = (input, investmentStrategyKey) => {
  const allFunds = [];
  const memberships = Array.isArray(input?.memberships)
    ? input?.memberships
    : [input];

  memberships?.forEach((membership) => {
    membership?.funds.forEach((fund) => {
      const fundWithMembershipId = {
        ...fund,
        membershipId: membership?.membershipId,
      };
      allFunds.push(fundWithMembershipId);
    });
  });

  const filteredFunds = allFunds.filter((fund) => {
    if (investmentStrategyKey === "futurePaymentsOnly") {
      return fund.fundPercentage !== 0;
    } else {
      return fund.balancePercent !== 0;
    }
  });

  return filteredFunds;
};

export const removeCashFundTotal = (changeInvestmentfunds) => {
  let investments = { ...changeInvestmentfunds };
  let totalBalanceToSubtract = 0;

  investments.memberships.map((membership) => {
    membership.funds.map((fund) => {
      if (fund.fundName?.toLowerCase() === "cash") {
        totalBalanceToSubtract += fund.balance;
        return {
          ...membership,
          totalFund: membership.totalFund - fund.balance,
        };
      }
    });
  });

  investments.totalFund -= totalBalanceToSubtract;

  return investments;
};

export const removeFundAndUpdateTotals = (data) => {
  let investments = [...data.memberships]; // Create a shallow copy

  investments?.forEach((membership) => {
    let cashFund = membership.funds.find((fund) => fund.fundName === "Cash");
    let pendingTrades = membership.funds.find(
      (fund) => fund.fundName === "Pending Trades",
    );
    if (!cashFund) return; // No cash fund found

    let distributableFunds = membership.funds.filter(
      (fund) =>
        fund.fundName !== "Cash" &&
        fund.fundType !== "Pending transactions" &&
        fund.fundName !== "Pending Trades" // eslint-disable-line
    );

    let totalPercentageToDistribute = cashFund.balancePercent;
    if (cashFund !== undefined) {
      cashFund.balancePercent = 0; // Set cash fund balance percent to 0
    }
    if (pendingTrades !== undefined) {
      pendingTrades.balancePercent = 0;
    }

    if (distributableFunds.length === 0) return;

    let totalCurrentBalancePercent = distributableFunds.reduce(
      (sum, fund) => sum + fund.balancePercent,
      0 // eslint-disable-line
    );
    if (
      totalCurrentBalancePercent === 0 ||
      totalCurrentBalancePercent === 100
    ) {
      return;
    } else {
      distributableFunds.forEach((fund) => {
        let proportion = fund.balancePercent / totalCurrentBalancePercent;
        fund.balancePercent = parseFloat(
          (
            fund.balancePercent +
            proportion * totalPercentageToDistribute
          ).toFixed(2),
        );
      });
    }
  });
  return removeCashFundTotal(data);
};

export const containsPre99 = (member) => {
  return member?.memberships[0]?.funds.some((fund) =>
    fund.fundName.includes("Pre 1999"),
  );
};

export const containsPre99Drawdown = (member) => {
  return member?.some((fund) => fund.fundName.includes("Pre 1999"));
};

export const getAllStrategies = (data) => {
  let strategiesMap = new Map();
  let totalCash = 0;

  data?.memberships?.forEach((membership) => {
    membership?.drawdownCategories?.forEach((category) => {
      category?.strategies?.forEach((strategy) => {
        if (strategy.strategyName === "Flexi-access") {
          strategy?.investments?.forEach((investment) => {
            if (investment.fundName?.toLowerCase() === "cash") {
              totalCash += parseFloat(investment.balance);
            }
          });
        }

        const existingStrategy = strategiesMap?.get(strategy.strategyName);

        if (existingStrategy) {
          existingStrategy.currentValue =
            parseFloat(existingStrategy.currentValue) +
            parseFloat(strategy.currentValue);
          existingStrategy.currentIncome =
            parseFloat(existingStrategy.currentIncome) +
              parseFloat(strategy.currentIncome) || 0;
        } else {
          strategiesMap.set(strategy.strategyName, {
            ...strategy,
            currentIncome: parseFloat(strategy.currentIncome) || 0,
          });
        }
      });
    });
  });

  if (strategiesMap.has("Flexi-access")) {
    strategiesMap.get("Flexi-access").currentValue -= totalCash;
  }

  if (totalCash > 0) {
    strategiesMap.set("Cash", {
      strategyName: "Cash",
      currentValue: totalCash,
      currentIncome: 0,
      color: COLOR_PALETTE[COLOR_PALETTE.length - 1],
    });
  }

  return Array.from(strategiesMap.values());
};

export const extractStrategies = (input, cmsStrategy) => {
  const allStrategies = [];
  const categories = Array.isArray(input?.drawdownCategories)
    ? input.drawdownCategories
    : [input];

  categories?.forEach((category) => {
    category?.strategies?.forEach((strategy) => {
      const strategies = {
        ...strategy,
        category: category.category,
      };
      if (strategy.strategyName === "Tax-free cash as income") {
        strategies.strategyPercentage = 0;
      }
      allStrategies.push(strategies);
    });
  });

  cmsStrategy?.forEach((strategy) => {
    const isExistingStrategy = allStrategies?.some(
      (existingStrategy) =>
        existingStrategy?.strategyName
          ?.toLowerCase()
          .includes(strategy?.strategyName?.toLowerCase()) ||
        strategy?.strategyName
          ?.toLowerCase()
          .includes(existingStrategy?.strategyName?.toLowerCase()) ||
        existingStrategy?.strategyId === strategy?.strategyId,
    );
    if (!isExistingStrategy) {
      allStrategies?.push(strategy);
    }
  });

  let fundIndexgt = allStrategies.findIndex(
    (fund) =>
      fund.strategyName === STRATEGIES.FLEXI_ACCESS && fund.currentValue > 0,
  );
  let fundIndexlt = allStrategies.findIndex(
    (fund) =>
      fund?.strategyName === STRATEGIES.FLEXI_ACCESS && fund.currentValue <= 0,
  );
  if (fundIndexgt !== -1) {
    allStrategies.splice(fundIndexgt + 1, 0, {
      strategyId: uuidv4(),
      category: "Self-managed",
      strategyName: "enable-flexi-access",
      currentValue: 0,
      currentIncome: allStrategies?.filter(
        (fund) => fund?.strategyName === STRATEGIES.FLEXI_ACCESS,
      )[0]?.currentIncome,
      duration: allStrategies?.filter(
        (fund) => fund?.strategyName === STRATEGIES.FLEXI_ACCESS,
      )[0]?.duration,
      strategyPercentage: 0,
    });
  } else if (fundIndexlt !== -1) {
    allStrategies.splice(fundIndexlt + 1, 0, {
      strategyId: uuidv4(),
      category: "Self-managed",
      strategyName: "disable-flexi-access",
      currentValue: 0,
      strategyPercentage: 0,
    });
  }

  return allStrategies;
};

export const extractDrawdownStrategies = (input) => {
  const allStrategies = [];
  const categories = Array.isArray(input?.drawdownCategories)
    ? input.drawdownCategories
    : [input];
  categories?.forEach((category) => {
    category?.strategies?.forEach((strategy) => {
      const strategies = {
        ...strategy,
        category: category.category,
      };
      allStrategies.push(strategies);
    });
  });
  return allStrategies;
};

export const assignColorToFunds = (
  data,
  fundColors,
  traUpdate,
  traAccountIds,
  accountDetailsForSavings,
) => {
  let colorIndex = 0;
  const colors = fundColors;

  const mutableData = JSON.parse(JSON.stringify(data));
  mutableData?.memberships?.forEach((membership) => {
    membership.funds = membership?.funds?.filter(
      (fund) => !(fund.fundPercentage === 0 && fund.balancePercent === 0),
    );
    membership?.funds?.forEach((fund) => {
      fund.color = colors[colorIndex % colors.length];
      colorIndex++;

      //Check for the fundName "GP3" and assign fundType
      if (
        fund.fundName === "TPT Money Market Fund" ||
        fund.fundName === "SIPP TPT Money Market Fund"
      ) {
        fund.fundType = "Managed for me";
      } else if (
        fund.fundName?.toLowerCase().includes("cash") &&
        fund.fundName?.toLowerCase() !== "cash fund" &&
        fund.fundName?.toLowerCase() !== "sipp tpt cash fund" &&
        fund.fundName?.toLowerCase() !== "tpt cash fund"
      ) {
        if (fund.balancePercent !== 0) {
          fund.fundType = "Pending transactions";
        }
      } else if (fund.fundName?.toLowerCase() === "pending trades") {
        if (fund.balancePercent !== 0) {
          fund.fundType = "Pending transactions";
        }
      }
    });
  });

  mutableData?.memberships?.forEach((member) => {
    accountDetailsForSavings?.forEach((account) => {
      if (member.membershipId === parseInt(account.accountId)) {
        member.memberType = [];
        if (account.active) member.memberType.push("active");
        if (account.deffered) member.memberType.push("deferred");
        if (account.drawdown) member.memberType.push("drawdown");
        if (account.inactive) member.memberType.push("inactive");
        if (account.recentActive) member.memberType.push("recentActive");
      }
    });
  });

  if (traUpdate === false) {
    mutableData?.memberships?.forEach((membership) => {
      if (traAccountIds.includes(membership.membershipId)) {
        membership.status = "locked";
        if (membership.strategyName === "") {
          membership.strategyName = "currentInvestmentsOnly";
        }
      }
    });
  }

  // Check if all memberships are locked
  const allLocked = mutableData.memberships?.every(
    (membership) => membership.status === "locked",
  );

  if (allLocked) {
    mutableData.status = "locked";
  }

  return mutableData;
};

export const assignColorToDrawdownFunds = (
  data,
  fundColors,
  traUpdate,
  traAccountIds,
) => {
  let colorIndex = 0;
  const colors = fundColors;

  const mutableData = JSON.parse(JSON.stringify(data));

  mutableData?.memberships?.forEach((membership) => {
    membership?.drawdownCategories?.forEach((category) => {
      // Filter out strategies with empty strategyId
      category.strategies = category.strategies.filter(
        (strategy) => strategy.strategyId !== "",
      );
      category?.strategies?.forEach((strategy) => {
        strategy.color = colors[colorIndex % colors.length];
        colorIndex++;
        strategy?.investments?.forEach((investment) => {
          investment.color = colors[colorIndex % colors.length];
          colorIndex++;
        });
      });
    });
    membership.correctDate = data?.correctDate;
  });

  if (traUpdate === false) {
    mutableData?.memberships?.forEach((membership) => {
      if (traAccountIds.includes(membership.membershipId)) {
        membership.status = "locked";
      }
    });
  }

  // Check if all memberships are locked
  const allLocked = mutableData.memberships?.every(
    (membership) => membership.status === "locked",
  );

  if (allLocked) {
    mutableData.status = "locked";
  }

  return mutableData;
};

export const addFourMonths = () => {
  let dt = new Date();
  let no_of_months = 4;
  dt.setMonth(dt.getMonth() + no_of_months);
  return dt;
};

export const updateCMSFunds = (selectedFunds, cmsFunds) => {
  // Create a map for quick lookup of selectedFunds by id
  const selectedFundMap = new Map(
    selectedFunds?.map((fund) => [fund?.investmentId, fund]),
  );
  // Iterate over cmsFunds and update if a matching id is found in selectedFunds
  for (let i = 0; i < cmsFunds?.length; i++) {
    const fund = cmsFunds[i];
    if (fund && selectedFundMap?.has(fund.investmentId)) {
      cmsFunds[i] = {
        ...selectedFundMap?.get(fund?.investmentId),
        checked: true,
      };
      selectedFunds.splice(
        selectedFunds.findIndex((f) => f.investmentId === fund.investmentId),
        1,
      );
    }
  }
  return {
    updatedCMSFunds: cmsFunds,
    updatedSelectedFunds: selectedFunds,
  };
};
export const livingStandardData = (items) => {
  const singleCouple = [];
  items?.map((item, index) => {
    singleCouple.push({
      title: item.content.properties.livingStandards,
      value: item.content.properties.single || item.content.properties.couple,
      description: item.content.properties.whatStandardOfLivingCouldYouHave,
      iconName:
        index === 0 ? "minimum" : index === 1 ? "moderate" : "comfortable",
      details: [
        {
          iconName: "house",
          title: "House",
          description: item.content.properties.house,
        },
        {
          iconName: "holiday",
          title: "Holidays & leisure",
          description: item.content.properties.holidaysLeisure,
        },
        {
          iconName: "food",
          title: "Food & drink",
          description: item.content.properties.food,
        },
        {
          iconName: "clothing",
          title: "Clothing & personal",
          description: item.content.properties.clothingPersonal,
        },
        {
          iconName: "transport",
          title: "Transport",
          description: item.content.properties.transport,
        },

        {
          iconName: "helping",
          title: "Helping others",
          description: item.content.properties.helpingOthers,
        },
      ],
    });
  });
  return singleCouple;
};

export const correctInvestmentsData = (investmentData) => {
  console.log(investmentData); //TODO: need to removed
};

export const calculateMonthsAndYear = (totalValue, monthlyAmount) => {
  const annualGrowthRate = 0.05; // 5% growth per annum
  const annualInflationRate = 0.025; // 2.5% inflation per annum

  let adjustedTotalValue = totalValue;
  let totalMonths = 0;
  let previousValue = adjustedTotalValue;

  if (annualGrowthRate * totalValue >= monthlyAmount * 12) {
    return { years: "Infinite", months: 0 };
  }

  while (adjustedTotalValue > 0) {
    adjustedTotalValue -= monthlyAmount;
    totalMonths++;

    if (totalMonths % 12 === 0) {
      adjustedTotalValue *= 1 + annualGrowthRate; // Apply growth rate
      adjustedTotalValue /= 1 + annualInflationRate; // Apply inflation rate
    }

    // Break the loop if the adjustedTotalValue stops decreasing significantly
    if (Math.abs(previousValue - adjustedTotalValue) < 0.01) {
      break;
    }
    previousValue = adjustedTotalValue;

    if (totalMonths > 1000 * 12) {
      return { years: "Infinite", months: 0 };
    }
  }

  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;
  return {
    years: years,
    months: months,
  };
};

export const calculateDuration = (
  initialAmount,
  withdrawalAmount,
  frequency,
) => {
  // Convert to numbers safely
  const initial = Number(initialAmount);
  const withdraw = Number(withdrawalAmount);
  const freq = Number(frequency);

  // Validate inputs
  if (!initial || !withdraw || !freq || withdraw <= 0 || freq <= 0) {
    return { years: 0, months: 0 };
  }

  const totalPeriods = Math.floor(initial / withdraw);
  const totalMonths = totalPeriods * freq;

  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  return { years, months };
};

export const isDateInRange = (retirementDate, fromDate, toDate, fundName) => {
  const retirementYear = parseInt(retirementDate?.split("-")[0]);
  const fromYear = parseInt(fromDate);
  const toYear = parseInt(toDate);
  if (fundName?.includes("Pre 1999")) {
    return false;
  } else if (
    fromDate === null ||
    toDate === null ||
    retirementYear === fromYear ||
    retirementYear === toYear ||
    (retirementYear >= fromYear && retirementYear <= toYear)
  ) {
    return true;
  }
};

const hasPercentageBelowFive = (percentages) => {
  for (const percentage of percentages) {
    if (percentage < 5.4) {
      return true;
    }
  }
  return false;
};

const countPercentagesBelowFive = (percentages) => {
  let count = 0;
  for (const percentage of percentages) {
    if (percentage <= 5.4) {
      count++;
    }
  }
  return count;
};

export const calculatePercentage = (data, type, total) => {
  let percentages = [];
  // prettier-ignore
  if (type === "savings") {
    percentages = data.potInfo.map((pot) => {return parseFloat(data.totalValue) === 0 ? 0 : (parseFloat(pot.totalPotValue) / parseFloat(data.totalValue)) * 100} );
  } else if (type === "drawdown") {
    percentages = data.potInfo.map((pot) => {return parseFloat(data.totalValue) === 0 ? 0 : (parseFloat(pot.drawdownValue) / parseFloat(data.totalValue)) * 100} );
  } else if (type === "totalSDPots") {
    const total = data.reduce((acc, current) => {
      return acc + parseFloat(current.totalValue);
    }, 0);
    percentages = data?.map((pot) => (parseFloat(pot.totalValue) / parseFloat(total)) * 100);
  } else if (type === "breakdown") {
    percentages = data?.potBreakDown?.map(
      (value) => (value.contributedValue / total) * 100
    )
  }

  do {
    let remainingPercentage = 0;
    if (type === "savings" || type === "drawdown") {
      for (let i = 0; i < data.potInfo.length; i++) {
        if (percentages[i] < 5.4) {
          remainingPercentage += 5.4 - percentages[i];
          percentages[i] = 5.4;
        }
      }

      const deductionPerPercentage =
        remainingPercentage /
        (data.potInfo.length - countPercentagesBelowFive(percentages));

      for (let i = 0; i < data.potInfo.length; i++) {
        if (percentages[i] > 5.4) {
          percentages[i] -= deductionPerPercentage;
        }
      }
    } else if (type === "totalSDPots") {
      for (let i = 0; i < data?.length; i++) {
        if (percentages[i] < 5.4) {
          remainingPercentage += 5.4 - percentages[i];
          percentages[i] = 5.4;
        }
      }

      const deductionPerPercentage =
        remainingPercentage /
        (data?.length - countPercentagesBelowFive(percentages));

      for (let i = 0; i < data?.length; i++) {
        if (percentages[i] > 5.4) {
          percentages[i] -= deductionPerPercentage;
        }
      }
    } else if (type === "breakdown") {
      for (let i = 0; i < data?.potBreakDown?.length; i++) {
        if (percentages[i] < 5.4) {
          remainingPercentage += 5.4 - percentages[i];
          percentages[i] = 5.4;
        }
      }

      const deductionPerPercentage =
        remainingPercentage /
        (data?.potBreakDown?.length - countPercentagesBelowFive(percentages));

      for (let i = 0; i < data?.potBreakDown?.length; i++) {
        if (percentages[i] > 5.4) {
          percentages[i] -= deductionPerPercentage;
        }
      }
    }
  } while (hasPercentageBelowFive(percentages));
  return percentages;
};

export const allocateRemainingPercentage = (transformedData) => {
  transformedData.fromInvestments = transformedData?.fromInvestments.map(
    (item) => {
      const unitAmountString = String(item?.unitAmount ?? "");
      const decimalLength = unitAmountString.includes(".")
        ? unitAmountString.split(".")[1].length
        : 0;
      const numericUnitAmount = Number(item?.unitAmount);
      const [integerPart = "", decimalPart = ""] = unitAmountString.split(".");
      return {
        ...item,
        unitAmount:
          Number.isFinite(numericUnitAmount) && decimalLength > 3
            ? Number(`${integerPart}.${decimalPart.slice(0, 3)}`)
            : item.unitAmount,
      };
    },
  );
  const toInvestment = transformedData?.toInvestments;
  const initialPercentages = toInvestment?.map((i) => i.percentageAmount);
  const maxIdx = initialPercentages?.reduce(
    (idx, v, i, arr) => (v > arr[idx] ? i : idx),
    0,
  );

  const initialTotal = toInvestment.reduce(
    (sum, item) => sum + item.percentageAmount,
    0,
  );
  const remainingPercentage = 100 - initialTotal;

  transformedData.toInvestments = toInvestment?.map((item) => {
    const adjustedPercentage =
      item.percentageAmount +
      (item.percentageAmount / initialTotal) * remainingPercentage;
    return {
      ...item,
      percentageAmount: Math.round(adjustedPercentage * 100) / 100,
    };
  });

  const totalAfter = transformedData?.toInvestments.reduce(
    (s, it) => s + it.percentageAmount,
    0,
  );
  const diff = Math.round((100 - totalAfter) * 100) / 100;
  if (diff !== 0) {
    const t = transformedData?.toInvestments[maxIdx];
    transformedData.toInvestments[maxIdx] = {
      ...t,
      percentageAmount: Math.round((t.percentageAmount + diff) * 100) / 100,
    };
  }

  return transformedData;
};

export const groupFundByName = (funds) => {
  return funds?.reduce((acc, curr) => {
    const existingFund = acc.find((fund) => fund.fundName === curr.fundName);

    if (existingFund) {
      existingFund.balance += curr.balance;
    } else {
      acc.push({ ...curr });
    }
    return acc;
  }, []);
};

export const cleanSavingsFundData = (savingsData) => {
  const copiedData = { ...savingsData };
  let data = structuredClone(copiedData);
  if (data.savingsPots && data.savingsPots.potInfo) {
    data.savingsPots.potInfo = data?.savingsPots?.potInfo
      ?.filter((pot) => pot.totalPotValue !== "0.00")
      ?.map((pot) => ({
        ...pot,
        potBreakDown: pot?.potBreakDown?.filter(
          (breakdown) => breakdown.contributedValue !== "0.00",
        ),
      }));
  }
  if (data.drawDownPots && data.drawDownPots.potInfo) {
    data.drawDownPots.potInfo = data?.drawDownPots?.potInfo
      ?.filter((pot) => pot.drawdownValue !== "0.00")
      ?.map((pot) => ({
        ...pot,
        potBreakDown: pot?.potBreakDown?.filter(
          (breakdown) => breakdown.contributedValue !== "0.00",
        ),
      }));
  }
  return data;
};

function fillMissingMonthsForPots(pots, months) {
  let newPots = []; // Create a new array to hold the modified pots

  if (!pots || pots.length === 0) {
    return newPots;
  }

  for (let i = 0; i < pots?.length; i++) {
    const currentMonthData = pots[i];

    if (
      !currentMonthData ||
      !currentMonthData.month ||
      !currentMonthData.fundValue
    ) {
      continue;
    }

    const currentMonthIndex = months?.indexOf(currentMonthData.month);
    // Add previous months (if any) with the same fundValue as the previous month
    if (i > 0) {
      const previousMonthData = pots[i - 1];

      if (!previousMonthData || !previousMonthData.fundValue) {
        continue;
      }

      const previousMonthIndex = months?.indexOf(previousMonthData.month);
      let year = previousMonthData.year;

      for (let j = previousMonthIndex + 1; j < months.length; j++) {
        newPots.push({
          fundValue: previousMonthData?.fundValue,
          month: months[j],
          year: year,
        });

        if (j === months.length - 1) {
          year += 1;
          j = -1;
        }

        if (j + 1 === currentMonthIndex && year === currentMonthData.year) {
          break;
        }
      }
    }

    // Add the current month data
    newPots.push({
      fundValue: currentMonthData?.fundValue,
      month: currentMonthData?.month,
      year: currentMonthData?.year,
    });
  }

  return newPots;
}

export const fillMissingMonths = (data) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const clonedData = structuredClone(data);

  // Modify savingsTotalPots and drawdownTotalPots
  clonedData.savingsTotalPots = fillMissingMonthsForPots(
    clonedData.savingsTotalPots,
    months,
  );
  clonedData.drawdownTotalPots = fillMissingMonthsForPots(
    clonedData.drawdownTotalPots,
    months,
  );
  return clonedData;
};
//Formats date in DD/MM/YYYY
export const formattedDate = (date) => {
  const input = date;
  const [year, month, day] = input && input.split("-");
  const formatDate = `${day}/${month}/${year}`;
  return formatDate;
};

//Formats date in DD-MM-YYYY
export const getFormattedDate = (date) => {
  const input = date;
  const [year, month, day] = input && input.split("-");
  const formatDate = `${day}-${month}-${year}`;
  return formatDate;
};

export const checkAllCashPercentage = (data) => {
  if (!data?.memberships || data?.memberships?.length === 0) {
    return false;
  }

  return data?.memberships?.every((member) =>
    member?.funds?.some(
      (fund) =>
        fund.fundName?.toLowerCase() === "cash" && fund.balancePercent === 100,
    ),
  );
};

export const areNominationsEqual = (pots) => {
  if (pots.length < 2) return false;

  const sortNominations = (nominations) =>
    nominations
      .slice()
      .sort(
        (a, b) =>
          (a.firstName || "").localeCompare(b.firstName || "") ||
          (a.lastName || "").localeCompare(b.lastName || "") ||
          (a.relationship || "").localeCompare(b.relationship || "") ||
          (parseFloat(a.percent) || 0) - (parseFloat(b.percent) || 0) ||
          (a.beneficiaryType || "").localeCompare(b.beneficiaryType || ""),
      );

  const firstPotNominations = sortNominations(pots[0].nominations);
  return pots.every((pot, i) => {
    if (i === 0) return true;
    const currentPotNominations = sortNominations(pot.nominations);
    return (
      firstPotNominations.length === currentPotNominations.length &&
      firstPotNominations.every(
        (nom, j) =>
          (nom.firstName || "") ===
            (currentPotNominations[j].firstName || "") &&
          (nom.lastName || "") === (currentPotNominations[j].lastName || "") &&
          (nom.relationship || "") ===
            (currentPotNominations[j].relationship || "") &&
          (nom.percent || "") === (currentPotNominations[j].percent || "") &&
          (nom.beneficiaryType || "") ===
            (currentPotNominations[j].beneficiaryType || ""),
      )
    );
  });
};

// TO DO - Remove once chart works properly
export const fillMissingValues = (arr, start, end) => {
  let filledArray = [];
  let addedCount = 0;
  for (let i = start; i <= end; i++) {
    if (!arr.includes(i)) {
      filledArray.push(i);
      addedCount++;
    }
  }
  let completeArray = filledArray.concat(arr).sort((a, b) => a - b);
  return { completeArray, addedCount };
};

// TO DO - Remove once chart works properly
export const insertZerosAtBeginning = (count, arr) => {
  for (let i = 0; i < count; i++) {
    arr.unshift(0);
  }
  console.log(arr);
  return arr;
};

export const selectEveryNth = (arr, n) => {
  let result = [];
  for (let i = 0; i < arr.length; i += n) {
    result.push(arr[i]);
  }
  return result;
};
//To handle product overview page breadcrumb
export const toSentenceCase = (str) => {
  // Remove hyphens and add spaces
  const spacedStr = str.split("-").join(" ");
  // Convert only the first letter of the resulting string to uppercase
  return spacedStr.charAt(0).toUpperCase() + spacedStr.slice(1).toLowerCase();
};

export const deductFromFlexiAccess = (data) => {
  let copyData = data.map((strategy) => ({
    ...strategy,
    investments: strategy.investments?.map((investment) => ({ ...investment })),
  }));

  let flexiAccess = copyData.find(
    (strategy) => strategy.strategyName === "Flexi-access",
  );

  if (flexiAccess) {
    let amountToDeduct = flexiAccess.withdrawAmount;
    let totalValue = flexiAccess.currentValue; // Use currentValue instead
    let deductionPercentage = amountToDeduct / totalValue;

    flexiAccess.investments.forEach((investment) => {
      let deductionAmount =
        parseFloat(investment.balance) * deductionPercentage;
      investment.balance -= deductionAmount;
      investment.withdrawAmount = deductionAmount;
    });
  }
  return copyData;
};

export const isQuestion = (sentence) => {
  const questionWords = [
    "who",
    "what",
    "when",
    "where",
    "why",
    "how",
    "is",
    "are",
    "can",
    "does",
    "do",
    "did",
    "will",
    "shall",
    "should",
    "could",
    "would",
  ];
  const trimmedSentence = sentence.trim().toLowerCase();
  const firstWord = trimmedSentence.split(" ")[0];

  if (questionWords.includes(firstWord) && !trimmedSentence.endsWith("?")) {
    return sentence + "?";
  }
  return sentence;
};

export const updateFlexiAccessInvestments = (strategy) => {
  const investments = strategy.investments2;
  const currentValue2 = parseFloat(strategy.currentValue2);
  const totalBalance = investments.reduce(
    (sum, investment) => sum + parseFloat(investment.balance),
    0,
  );
  const difference = currentValue2 - totalBalance;

  // Calculate the percentage increase
  const strategyPercentage1 = parseFloat(strategy.strategyPercentage1);
  const strategyPercentage2 = parseFloat(strategy.strategyPercentage2);
  const percentageIncrease = strategyPercentage2 / strategyPercentage1;

  investments.forEach((investment) => {
    const balance = parseFloat(investment.balance);
    const balancePercentage = balance / totalBalance;
    const additionalAmount = balancePercentage * difference;
    investment.newBalance = balance + additionalAmount;

    if (
      investment.balancePercent === undefined ||
      parseFloat(investment.balancePercent) === 0
    ) {
      investment.balancePercent = 0;
      investment.fundPercentage = (
        (balance / currentValue2) *
        strategyPercentage2
      ).toFixed(2);
    } else {
      investment.fundPercentage = (
        investment.balancePercent * percentageIncrease
      ).toFixed(2);
    }
  });
};

export const calculateVintage = (birthYear) => {
  if (!birthYear || isNaN(birthYear)) {
    return {
      error: "Invalid birth year",
    };
  }

  const age75Year = parseInt(birthYear) + 75;
  const age95Year = parseInt(birthYear) + 95;

  return {
    age75Year: age75Year,
    age95Year: age95Year,
  };
};

export const findFunds = (data, age75Year, age95Year) => {
  const age75Fund = data?.find((item) => {
    const { fundFrom, fundTo, fundName } = item.content.properties;
    if (fundName?.toLowerCase() === "future annuity income fund") {
      return (
        (age75Year >= fundFrom && age75Year <= fundTo) ||
        age75Year === fundFrom ||
        age75Year === fundTo
      );
    }
  });

  const age95Fund = data?.find((item) => {
    const { fundFrom, fundTo, fundName } = item.content.properties;
    if (fundName?.toLowerCase() === "managed income fund") {
      return (
        (age95Year >= fundFrom && age95Year <= fundTo) ||
        age95Year === fundFrom ||
        age95Year === fundTo
      );
    }
  });

  const legacyFund = data?.find(
    (item) => item.content.properties.fundName?.toLowerCase() === "legacy fund",
  );
  const safetyNetFund = data?.find(
    (item) =>
      item.content.properties.fundName?.toLowerCase() === "safety net fund",
  );
  const annuityAwareFund = data?.find(
    (item) =>
      item.content.properties.fundName?.toLowerCase() === "annuity aware fund",
  );

  return [
    age75Fund ? age75Fund.content.properties : null,
    age95Fund ? age95Fund.content.properties : null,
    legacyFund ? legacyFund.content.properties : null,
    safetyNetFund ? safetyNetFund.content.properties : null,
    annuityAwareFund ? annuityAwareFund.content.properties : null,
  ].filter((fund) => fund !== null); // Filter out null values
};

export const updateFlexiAccessStrategy = (membership) => {
  const flexiAccessStrategy = membership.drawdownCategories
    .find((category) => category.category === "Self-managed")
    ?.strategies.find((strategy) => strategy.strategyName === "Flexi-access");

  if (flexiAccessStrategy) {
    let investments = flexiAccessStrategy?.investments;

    // Remove investments with balance 0
    investments = investments?.filter(
      (investment) => parseFloat(investment?.balance) !== 0,
    );
    flexiAccessStrategy.investments = investments;

    // Function to remove an investment and adjust values
    const removeInvestment = (investmentName) => {
      const investmentIndex = investments.findIndex(
        (investment) => investment?.fundName?.toLowerCase() === investmentName,
      );
      if (investmentIndex !== -1) {
        const investment = investments[investmentIndex];
        const balance = parseFloat(investment.balance);

        // Deduct the balance from currentValue and totalFund
        flexiAccessStrategy.currentValue -= balance;
        membership.totalFund -= balance;

        // Remove the investment
        investments.splice(investmentIndex, 1);
      }
    };

    // Remove the "Cash" investment
    removeInvestment("cash");

    // Remove the "Pending Trades" investment
    removeInvestment("pending trades");
  }

  return normalizeMixedPercentages(membership);
};

function normalizeMixedPercentages(data) {
  let items = [];

  // Collect strategies from For Growth and For Income
  data?.drawdownCategories?.forEach((category) => {
    if (
      category?.category === "For Growth" ||
      category?.category === "For Income"
    ) {
      category?.strategies?.forEach((strategy) => {
        const value = parseFloat(strategy?.currentValue || 0);
        items.push({
          type: "strategy",
          ref: strategy,
          value: value,
        });
      });
    }
  });

  // Collect investments from Flexi-access under Self-managed
  const selfManaged = data?.drawdownCategories?.find(
    (c) => c.category === "Self-managed",
  );

  let flexiAccessInvestments = [];
  let flexiAccessStrategy = null;

  if (selfManaged) {
    const flexiAccess = selfManaged?.strategies.find(
      (s) => s.strategyName === "Flexi-access",
    );
    if (flexiAccess && flexiAccess?.investments?.length > 0) {
      flexiAccessStrategy = flexiAccess;
      flexiAccess?.investments?.forEach((investment) => {
        const balance = parseFloat(investment?.balance || 0);
        const item = {
          type: "investment",
          ref: investment,
          value: balance,
        };
        items?.push(item);
        flexiAccessInvestments?.push(item);
      });
    }
  }

  // Calculate total value
  const totalValue = items?.reduce((sum, item) => sum + item.value, 0);

  // Distribute 100% proportionally
  items?.forEach((item) => {
    const percent = totalValue
      ? ((item.value / totalValue) * 100).toFixed(2)
      : "0.00";
    if (item.type === "strategy") {
      item.ref.strategyPercentage = percent;
    } else if (item.type === "investment") {
      item.ref.balancePercent = percent;
    }
  });

  // Assign sum of balancePercent to Flexi-access strategyPercentage
  if (flexiAccessStrategy && flexiAccessInvestments.length > 0) {
    const flexiTotalPercent = flexiAccessInvestments?.reduce(
      (sum, item) => sum + parseFloat(item.ref.balancePercent || 0),
      0,
    );
    flexiAccessStrategy.strategyPercentage = flexiTotalPercent?.toFixed(2);
  }

  return data;
}

// Identify application is having context
export const hasContextPath = () => {
  return process.env.REACT_APP_ENV === "dev"
    ? "/dev"
    : process.env.REACT_APP_ENV === "qa"
      ? "/qa"
      : process.env.REACT_APP_ENV === "uat"
        ? "/uat"
        : "";
};

export const calculateMonthlyIncome = (
  fundValue,
  incomeRate,
  currentUnitPrice,
) => {
  // Calculate the annual income
  if (parseFloat(currentUnitPrice) !== 0) {
    const annualIncome = (fundValue * incomeRate) / currentUnitPrice; // Calculate the monthly income
    const monthlyIncome = annualIncome / 12;
    if (isNaN(monthlyIncome)) {
      return 0;
    } else {
      return monthlyIncome;
    }
  } else return 0;
};

export const checkAndRemovePendingTrade = (data) => {
  const dataCopy = JSON.parse(JSON.stringify(data));

  dataCopy?.memberships?.forEach((membership) => {
    const pendingTrades = membership?.funds?.find(
      (fund) => fund.fundName === "Pending Trades",
    );

    if (pendingTrades?.balance < 0) {
      checkAndAdjustBalancePercentage(membership);
    } else {
      updateMembershipData(membership, dataCopy);
    }
  });

  return dataCopy;
};

export const checkAndAdjustBalancePercentage = (membership) => {
  let totalBalancePercent = 0;
  let totalBalance = 0;

  membership.funds.forEach((fund) => {
    if (fund?.fundName !== "Cash" && fund?.fundName !== "Pending Trades") {
      totalBalancePercent += fund?.balancePercent;
      totalBalance += fund?.balance;
    }
  });

  // Remove "Pending Trades" object
  membership.funds = membership?.funds.filter(
    (fund) => fund?.fundName !== "Pending Trades",
  );

  // Adjust "Cash" balance and balancePercent to ensure total is 100%
  const remainingPercent = 100 - totalBalancePercent;
  const remainingBalance = membership?.totalPotValue - totalBalance;

  membership.funds.forEach((fund) => {
    if (fund.fundName === "Cash") {
      fund.balancePercent = remainingPercent;
      fund.balance = remainingBalance;
    }
  });
};

export const updateMembershipData = (membership, dataCopy) => {
  const funds = membership?.funds;
  const pendingTrade = funds.find((fund) => fund.fundName === "Pending Trades");

  if (pendingTrade) {
    // Remove the pending trade object
    const index = funds.indexOf(pendingTrade);
    funds.splice(index, 1); // Adjust totalPotValue and totalFund

    const pendingBalance = pendingTrade?.balance;
    membership.totalPotValue -= pendingBalance;
    dataCopy.totalFund -= pendingBalance; // Calculate the total balancePercent of remaining funds

    const totalBalancePercent = funds?.reduce(
      (sum, fund) => sum + fund?.balancePercent,
      0,
    ); // Distribute the balancePercent proportionally

    funds?.forEach((fund) => {
      fund.balancePercent = parseFloat(
        ((fund?.balancePercent / totalBalancePercent) * 100)?.toFixed(2),
      );
    });
  }
};

export const getEmployerContribution = (empContribution, grades) => {
  let employerContribution = 0;
  if (grades.erAmountType === erAmountType.APS) {
    employerContribution = grades.erAmount;
  } else if (grades.erAmountType === erAmountType.RM) {
    employerContribution = parseFloat(empContribution) * grades.erAmount;
  } else if (grades.erAmountType === erAmountType.RPS) {
    employerContribution = parseFloat(empContribution) + grades.erAmount;
  } else {
    return employerContribution;
  }
  return employerContribution;
};

export const getEmpErValues = (grades) => {
  let empValue = 0;
  let erValue = 0;

  if (grades?.gradesData?.length === 2) {
    const hasAPS = grades.gradesData.some(
      (item) => item.erAmountType === erAmountType.APS,
    );
    const hasRPS = grades.gradesData.some(
      (item) => item.erAmountType === erAmountType.RPS,
    );
    const hasRM = grades.gradesData.some(
      (item) => item.erAmountType === erAmountType.RM,
    );

    const rmObject = grades.gradesData.find(
      (item) => item.erAmountType === erAmountType.RM,
    );
    const rpsObject = grades.gradesData.find(
      (item) => item.erAmountType === erAmountType.RPS,
    );
    const apsObject = grades.gradesData.find(
      (item) => item.erAmountType === erAmountType.APS,
    );

    if (hasAPS && hasRM && apsObject && rmObject) {
      empValue = Math.min(apsObject.eeMin, rmObject.eeMax);
      erValue = Math.max(
        apsObject.erAmount,
        rmObject.erAmount * rmObject.eeMax,
      );
    } else if (hasAPS && hasRPS && apsObject && rpsObject) {
      empValue = Math.min(apsObject.eeMin, rpsObject.eeMax);
      erValue = Math.max(
        apsObject.erAmount,
        rpsObject.erAmount + rpsObject.eeMax,
      );
    }
  } else if (grades?.gradesData?.length === 1) {
    empValue =
      grades.erAmountType === erAmountType.APS ? grades.eeMin : grades.eeMax;
    erValue = grades.erMax;
  }
  return { empValue, erValue };
};

export const isSalarySacrifice = (accountInfo) => {
  return accountInfo.salarySacrificeFlag;
};

export const isGradeException = (grades) => {
  if (grades?.gradesData?.length > 2 || grades?.gradesData?.length === 0) {
    return true;
  } else {
    return false;
  }
};

export const formatGBP = (value) => {
  if (value === "") return "£";
  const [intPart, decimalPart] = value.split(".");
  const formattedInt = parseInt(intPart || "0", 10).toLocaleString("en-GB");
  return (
    "£" + formattedInt + (decimalPart !== undefined ? "." + decimalPart : "")
  );
};

export const isHybridMember = (membershipType) => {
  return (
    membershipType?.includes(MEMBERSHIPTYPE?.HYBRID) ||
    membershipType?.includes(MEMBERSHIPTYPE?.DC_TVIN) ||
    membershipType?.includes(MEMBERSHIPTYPE?.DC_AVC_PAYER)
  );
};

export const employerContribution = (rates) => {
  return rates.employerFixedPercent - rates.salSacrificeFixedPercent;
};

export const insertRetirementAgeMarkerInStrategies = (
  potLineData,
  retirementAge,
) => {
  const updatedData = JSON.parse(JSON.stringify(potLineData));

  updatedData?.potValueLineGraph?.forEach((strategyObj) => {
    const potValues = strategyObj.potValues;

    const retirementIndex = potValues.findIndex(
      (entry) => entry.age === retirementAge,
    );

    if (retirementIndex > 0) {
      // Update the age of the previous entry to match the retirement age
      potValues[retirementIndex - 1].age = retirementAge;
    }
    // If retirementIndex === 0, we ignore it as per your instruction
  });

  return updatedData;
};

export const parseInputValue = (rawValue) => {
  let value = rawValue?.replace("%", "");

  // Remove leading zeros unless it's "0" or starts with "0."
  if (value.length > 1 && value.startsWith("0") && !value.startsWith("0.")) {
    value = value.replace(/^0+/, "");
  }

  // Allow only numbers with up to 2 decimal places
  const isValidFormat = /^\d{0,3}(\.\d{0,2})?$/.test(value);
  const numericValue = parseFloat(value);

  const isValidRange =
    value === "" ||
    (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 100);

  if (isValidFormat && isValidRange) {
    return {
      formattedValue: value + "%",
      numericValue: value,
    };
  }

  return null; // Invalid input
};

export const sanitizeInputOnBlur = (rawValue) => {
  let value = rawValue?.replace("%", "");

  // Remove trailing dot if present (e.g., "45." → "45")
  if (value.endsWith(".")) {
    value = value.slice(0, -1);
  }

  return value;
};

export const isGP3 = (selectedItem) =>
  selectedItem?.schemeName === "Growth Plan Series 3";

export const calculateAgeAtDate = (birthdate, targetDate) => {
  const birthDate = new Date(birthdate);
  const target = new Date(targetDate);
  let age = target?.getFullYear() - birthDate?.getFullYear();
  const monthDiff = target?.getMonth() - birthDate?.getMonth();
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && target?.getDate() < birthDate?.getDate())
  ) {
    age--;
  }
  return age;
};

export const convertToISODateFormat = (date) => {
  const year = date?.getFullYear();
  const month = String(date?.getMonth() + 1)?.padStart(2, "0"); // Months are 0-indexed
  const day = String(date?.getDate())?.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatPercentage = (value) => {
  const num = Number(value);
  const fixed = num?.toFixed(2);
  return fixed?.endsWith("00")
    ? num?.toFixed(2)
    : fixed?.endsWith("0")
      ? num?.toFixed(2)
      : fixed;
};

export const flagStrategies95To100 = (strategies) => {
  if (!Array.isArray(strategies)) return strategies;

  return strategies.map((item) => {
    // Skip null/undefined entries
    if (!item || typeof item !== "object") return item;

    // Coerce to numbers safely
    const cv1 = Number(item.currentValue1);
    const cv2 = Number(item.currentValue2);

    // Defaults
    let pct = null;
    let flag = false;

    // Validate numbers and avoid divide-by-zero
    if (Number.isFinite(cv1) && Number.isFinite(cv2) && cv1 > 0) {
      const diff = cv1 - cv2;
      pct = (diff / cv1) * 100;

      flag = pct >= 95 && pct < 100;
    }

    item.diffPercentage = flag;
    item.diffValue = pct;

    return item;
  });
};

export const getStrategyNamesForFlagTrue = (finalCombinedArray) => {
  if (!Array.isArray(finalCombinedArray)) return [];

  const names = finalCombinedArray
    .filter(
      (item) => item && typeof item === "object" && item.diffPercentage === true //eslint-disable-line
    )
    .map((item) => item.strategyName)
    .filter((name) => typeof name === "string" && name.trim().length > 0);

  // De-duplicate while preserving order
  return [...new Set(names)];
};

export const openPopup = (url) => {
  const width = 1200;
  const height = 600;
  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;
  const popup = window.open(
    cmsConfig.baseUrl + url,
    "PopupWindow",
    `width=${width},height=${height},left=${left},top=${top}` //eslint-disable-line
  );
  if (popup) {
    popup.focus();
  } else {
    alert("Popup blocked! Please allow popups for this site.");
  }
};

export const isAllInCashOrPending = (onlyCash) => {
  const selfManagedInvestments = (onlyCash?.memberships || []).flatMap(
    (membership) =>
      (membership.drawdownCategories || [])
        .filter((c) => c.category === "Self-managed")
        .flatMap((c) =>
          (c.strategies || []).flatMap((s) => s.investments || []),
        ),
  );

  const toNum = (v) => {
    const n =
      typeof v === "number"
        ? v
        : parseFloat(String(v || "0").replace(/,/g, ""));
    return isNaN(n) ? 0 : n;
  };

  const total = selfManagedInvestments.reduce(
    (sum, investment) => sum + toNum(investment.balance),
    0,
  );

  const cashPendingTotal = selfManagedInvestments
    .filter((investment) =>
      /^(cash|pending trades)$/i.test(investment.fundName.toLowerCase() || ""),
    )
    .reduce((sum, investment) => sum + toNum(investment.balance), 0);

  return total === cashPendingTotal;
};

export const sanitizeHTML = (html = "") => DOMPurify.sanitize(html);
